import usePrivateAxios from "@/common/api/usePrivateAxios";
import { UseQueryResult, useQuery } from "@tanstack/react-query";
import { CardData, CardResponse } from "../types/card.type";

type UseCardType = ({ }: { id?: string; }) => UseQueryResult<CardData, unknown>;

const useCard: UseCardType = ({ id }) => {
  const privateAxios = usePrivateAxios()

  return useQuery<CardResponse, unknown, CardData>({
    enabled: !!id,
    queryKey: ['clientCard', id],
    queryFn: () => {
      return privateAxios.get(`/client/cards/${id}`);
    },
    select: (data) => data?.data?.data,
  });
};

export default useCard;
